import { FC } from 'react'
import { StyleSheet, View } from 'react-native'
import { Button, Dialog, Portal, Text } from 'react-native-paper'
import { ColorsEnum } from '../../constants/colors'
import { FontsEnum } from '../../constants/fonts'
import { useAppDispatch, useAppSelector } from '../../hooks/redux'
import { appSelectors, setIsLogoutDialog } from '../../redux/reducers/app'
import { logout } from '../../redux/reducers/app/action-creators'
import { performHaptics } from '../../utils/performHaptics'

const LogoutDialog: FC = () => {
    const isLogoutDialog = useAppSelector(appSelectors.isLogoutDialog)

    const dispatch = useAppDispatch()

    const handlePress = async () => {
        performHaptics()

        dispatch(logout())
    }

    const handleDismiss = () => {
        dispatch(setIsLogoutDialog(false))
    }

    const handleClose = () => {
        performHaptics()

        dispatch(setIsLogoutDialog(false))
    }

    return (
        <Portal>
            <Dialog visible={isLogoutDialog} onDismiss={handleDismiss} style={styles.dialog}>
                <Dialog.Title style={styles.title}>Odhlášení</Dialog.Title>
                <Dialog.Content>
                    <Text style={styles.text}>Opravdu si přejete odhlásit?</Text>
                </Dialog.Content>
                <Dialog.Actions>
                    <View>
                        <Button onPress={handleClose} contentStyle={styles.buttonContent}>
                            <Text style={styles.buttonText}>Ne</Text>
                        </Button>
                    </View>
                    <View>
                        <Button
                            mode="outlined"
                            onPress={handlePress}
                            style={styles.button}
                            contentStyle={styles.buttonContent}
                        >
                            <Text style={styles.buttonText}>Ano</Text>
                        </Button>
                    </View>
                </Dialog.Actions>
            </Dialog>
        </Portal>
    )
}

const styles = StyleSheet.create({
    dialog: {
        alignSelf: 'center',
        backgroundColor: '#FFFFFF',
        width: 475,
    },
    title: {
        fontFamily: FontsEnum.RUBIK_500_MEDIUM,
    },
    text: {
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
        fontSize: 19,
    },
    button: {
        borderColor: ColorsEnum.PRIMARY,
    },
    buttonContent: {
        height: 45,
        minWidth: 78,
    },
    buttonText: {
        color: ColorsEnum.PRIMARY,
        fontFamily: FontsEnum.RUBIK_400_REGULAR,
    },
})

export default LogoutDialog
